import React from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import SwiperCore, { Navigation, Pagination } from "swiper"

import { withTestimonials } from "./withTestimonials"
import { TestimonialsImage } from "./Image/TestimonialsImage"
import { TestimonialsItem } from "./Item/TestimonialsItem"
import { TestimonialsNavigation } from "./Navigation/TestimonialsNavigation"
import { Section, Gradient, Indicators } from "./TestimonialsStyles"

SwiperCore.use([Navigation, Pagination])

export const Testimonials = withTestimonials(
  ({ id, image, items, handleInit, handleSlideChange, length }): JSX.Element => (
    <Section>
      {items?.map((item: any, index: number) => (
        <TestimonialsImage key={item?.key} active={image === index} image={item?.image} index={index} />
      ))}
      <Gradient />
      <Swiper
        loop={length}
        navigation={length ? { prevEl: `#${id}-Left`, nextEl: `#${id}-Right` } : false}
        onSlideChange={length ? handleSlideChange : null}
        pagination={length ? { clickable: true, el: `#${id}-pagination` } : false}
        onSwiper={length ? handleInit : null}
      >
        {items?.map((item: any) => (
          <SwiperSlide key={item?.key}>
            <TestimonialsItem item={item} />
          </SwiperSlide>
        ))}
      </Swiper>
      {length && (
        <>
          <TestimonialsNavigation direction={`Left`} id={id} />
          <TestimonialsNavigation direction={`Right`} id={id} />
          <Indicators id={`${id}-pagination`} large />
        </>
      )}
    </Section>
  )
)

export default Testimonials
